module.exports = require('../../full/object/entries');